<style src="css/offlineLectures.css" scoped></style>
<template>
    <div style="padding-top: .98rem;padding-bottom: .98rem">
        <div class="topBox"><span class="back" @click="back()"></span>讲座会诊</div>
        <div class="offlineBtn">
            <span :class="{active:offlineType===1}" @click="changeOfflineType(1)">线下讲座</span>
<!--            <span :class="{active:offlineType===2}" @click="changeOfflineType(2)">专家会诊</span>-->
            <span :class="{active:offlineType===2}" @click="changeOfflineType(2)">专家会诊</span>
        </div>
        <div v-if="noMore">
            <no-more-data :noMoreData="true"></no-more-data>
        </div>
        <div v-else>
            <div class="joinBox" v-if="offlineType===1">
                <div class="joinBtn">
                    <div class="join" :class="{active:lectureStatus===0}" @click="changeLectureStatus(0)">未参加</div>
                    <div class="join" :class="{active:lectureStatus===1}" @click="changeLectureStatus(1)">进行中</div>
                    <div class="join" :class="{active:lectureStatus===2}" @click="changeLectureStatus(2)">已参加</div>
                </div>
            </div>
            <div v-if="lectureStatus===0">
                <div class="lectureBox"   v-if="lectureStatus===0">
                    <div class="lectureItem" v-if="lectureList.length>0"><span>讲座时间：{{lectureList[0].lectureDate | time}}</span></div>
                    <div class="lectureItem" v-if="lectureList.length>0"><span>具体地址：{{lectureList[0].location}}</span></div>
                </div>
                <div class="box"   v-if="lectureStatus===0&&lectureList.length>0">
                    <div class="count">共{{lectureList[0].scaleGroupComboWorkLectureDTOList.length}}位矫正对象，其中{{num}}位有线下咨询</div>
                    <div class="mainItem" v-for="(item,index) in lectureList[0].scaleGroupComboWorkLectureDTOList" v-if="lectureList[0].scaleGroupComboWorkLectureDTOList.length>0" @click="changeStatus(index)">
                        <div class="c-center">
                            <div class="optionIcon" :class="{active:item.status}"></div>
                            <div class="tx"></div>
                        </div>

                        <div class="infoBox">
                            <div class="name">{{item.nickName}}  <div class="time" style="margin-left: 1rem" v-if="item.lectureType===1">线下咨询</div></div>
                            <div class="time">手机号：{{item.userPhone}}</div>

                            <div class="time">次数：{{item.joinTimes}}/{{item.times}}</div>
                            <div class="time" v-if="item.lastLectureTime">最近一次：{{item.lastLectureTime | time}}</div>
                        </div>
                    </div>
                </div>

                <div class="fixedBox" v-if="lectureStatus===0&&lectureList.length>0">
                    <div class="fixedLeft">
                        <div class="optionIcon" :class="{active:allStatus}" @click="changeAll()"></div>
                        全选
                    </div>
                    <div class="fixedRight">
                        <div>
                            <div class="totalBox">合计：<span>{{allTotal}}位</span></div>
                            <div class="totalBox">线下：<span>{{numTotal}}位</span></div>
                        </div>

                        <div class="submitBtn" @click="showMask()">提交申请</div>
                    </div>
                </div>
                <div class="maskBox" v-if="mask">
                    <div class="maskTipBox">
                        <div class="maskTip">
                            <div class="tipTitle">提示</div>
                            <div class="tipWord">所选人员名单是否确认无误，立即提交</div>
                        </div>
                        <div class="maskTipBottom">
                            <div class="mtl" @click="mask=false">取消</div>
                            <div class="mtr" @click="doJoinLecture">确定</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="lectureStatus===1">
                <div class="lectureNotesBox" v-for="item in lectureList">
                    <div class="lectureNotesTitleBox" @click="getLectureUser(item.lectureId)">
                        讲座记录
                        <div class="more"></div>
                    </div>
                    <div class="lectureNotesInfo fFixed">
                        <div>
                            参加人数：<span>{{item.joinCount}}人</span>
                        </div>
                        <div class="fBtn" @click="showFMask(item.lectureId)">完成讲座</div>
                    </div>
                    <div class="lectureNotesInfo">
                        讲座时间：<span>{{item.lectureDate | time}}</span>
                    </div>
                    <div class="lectureNotesInfo">
                        具体地址：<span>{{item.location}}</span>
                    </div>
                </div>
            </div>
            <div v-if="lectureStatus===2">
                <div class="lectureNotesBox" v-for="item in lectureList">
                    <div class="lectureNotesTitleBox" @click="getLectureUser(item.lectureId)">
                        讲座记录
                        <div class="more"></div>
                    </div>
                    <div class="lectureNotesInfo">
                        参加人数：<span>{{item.joinCount}}人</span>
                    </div>
                    <div class="lectureNotesInfo">
                        讲座时间：<span>{{item.lectureDate | time}}</span>
                    </div>
                    <div class="lectureNotesInfo">
                        具体地址：<span>{{item.location}}</span>
                    </div>
                </div>
            </div>

            <div class="lectureNotesMaskBox" v-if="lectureNotesMask">
                <div class="lectureNotesMaskTitle">
                    <div class="lectureNotesMaskClose" @click="lectureNotesMask=false"></div>
                    讲座记录
                </div>
                <div class="lectureBox" style="padding-top: 1rem">
                    <div class="lectureItem"><span>讲座时间：{{lectureUser.lectureDate | time}}</span></div>
                    <div class="lectureItem"><span>具体地址：{{lectureUser.location}}</span></div>
                </div>
                <div class="joinBox" v-if="offlineType===1">
                    <div class="joinBtn">
                        <div class="join" :class="{active:rosterStatus===''}" @click="changeRosterStatus('')">全部</div>
                        <div class="join" :class="{active:rosterStatus===0}" @click="changeRosterStatus(0)">仅讲座</div>
                        <div class="join" :class="{active:rosterStatus===1}" @click="changeRosterStatus(1)">线下咨询</div>
                    </div>
                </div>
                <div class="box">
                    <div class="count">共{{lectureUser.scaleGroupComboWorkLectureDTOList.length}}位矫正对象</div>
                    <div class="mainItem" v-for="(item,index) in lectureUser.scaleGroupComboWorkLectureDTOList" v-if="lectureUser.scaleGroupComboWorkLectureDTOList.length>0">
                        <!--                    <div class="optionIcon" :class="{active:item.status}"></div>-->
                        <div class="tx"></div>
                        <div class="infoBox">
                            <div class="name" style="width: 4.3rem">{{item.nickName}}</div>
                            <div class="time">手机号：{{item.userPhone}}</div>
                            <div class="time" v-if="item.lectureType===1">线下咨询</div>
                        </div>
                        <div class="n-btn" :class="{active:item.joinTimes===1}" @click="changeJoinTimes(item.workId,item.joinTimes)">{{item.joinTimes===1?'已到':'未到'}}</div>
                    </div>
                </div>
            </div>
            <div class="maskBox" v-if="FMask">
                <div class="maskTipBox">
                    <div class="maskTip">
                        <textarea placeholder="请输入您对本次讲座的记录，256字以内" v-model="remark" maxlength="256"></textarea>
                        <div class="num">{{remark.length}}/265</div>
                    </div>
                    <div class="maskTipBottom">
                        <div class="mtl" @click="FMask=false">取消</div>
                        <div class="mtr" @click="doCompleteLecture">确定</div>
                    </div>
                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>



    </div>

</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import footerBox from 'components/footer'
    import moment from 'moment/moment'


    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex:1,
                pageSize: 25,
                count: 0,
                noMoreData: false,
                isLoading:false,
                lectureList:[],
                lectureStatus:0,
                allStatus:false,
                allTotal:0,
                numTotal:0,
                mask:false,
                lectureNotesMask:false,
                lectureUser:'',
                offlineType:1,
                num:0,
                rosterStatus:'',
                lectureId:'',
                FMask:false,
                remark:'',
                remarkId:'',
                noMore:false
            }
        },
        components: {
            noMoreData,
            topbar,
            footerBox,
        },
        filters: {
            time(value) {
                if(value){
                    let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                    return transTime
                }

            },
            isTimes(value){
                let obj={
                    2:'二次',
                    4:'四次',
                    12:'十二次',
                    48:'四十八次',
                }
                if(value){
                    return obj[value]
                }
            }
        },
        computed: {},
        methods: {
            showFMask(id){
                this.FMask=true;
                this.remarkId=id;
            },
            changeJoinTimes(id,times){
                if(times){
                    this.doLectureRoster(id,0)
                }else{
                    this.doLectureRoster(id,1)
                }

            },
            changeOfflineType(n){
                this.offlineType=n;
                if(n==1){
                    this.noMore=false
                    this.init()
                }else{
                    this.noMore=true
                }

            },
            changeRosterStatus(n){
              this.rosterStatus=n;
              this.getLectureUser(this.lectureId)
            },
            back(){
                history.back();
            },
            init(){
                this.FMask=false;
                this.remarkId='';
                this.remark='';
                this.lectureList=[];
                this.pageIndex=1;
                this.noMoreData=false;
                this.mask=false;
                this.allTotal=0;
                this.allStatus=false;
                this.getLectureList();
            },
            changeLectureStatus(n){
                this.lectureStatus=n
                this.init();
            },
            changeAll(){
                if(this.allStatus){
                    this.lectureList[0].scaleGroupComboWorkLectureDTOList.forEach(v=>{
                        v.status=false;
                    })
                    this.allStatus=false;
                    this.allTotal=0;
                    this.numTotal=0;
                }else{
                    this.lectureList[0].scaleGroupComboWorkLectureDTOList.forEach(v=>{
                        v.status=true;
                    })
                    this.allStatus=true;
                    this.allTotal=this.lectureList[0].scaleGroupComboWorkLectureDTOList.length
                    this.numTotal=this.num
                }
            },
            changeStatus(index){
                if(this.lectureList[0].scaleGroupComboWorkLectureDTOList[index].status){
                    if(this.lectureList[0].scaleGroupComboWorkLectureDTOList[index].lectureType===1){
                        this.numTotal=this.numTotal-1
                    }
                    this.allTotal=this.allTotal-1
                }else{
                    if(this.lectureList[0].scaleGroupComboWorkLectureDTOList[index].lectureType===1){
                        this.numTotal=this.numTotal+1
                        console.log(1111111111)
                    }
                    this.allTotal=this.allTotal+1
                }

                this.lectureList[0].scaleGroupComboWorkLectureDTOList[index].status=!this.lectureList[0].scaleGroupComboWorkLectureDTOList[index].status;
            },
            to(n) {
                this.$router.push(`/${n}`)
            },

            showMask(){
                if(this.allTotal>0){
                    this.mask=true
                }else{
                    alert(`请选择矫正对象~`)
                }
            },
            async doCompleteLecture(id) {
                let data = await getSources("/bear-scale/api/scaleGroupComboWorkLecture/doCompleteLecture.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    lectureId:this.remarkId,
                    remark:this.remark,
                });
                if (data.status === 0) {
                    this.init()
                }else{
                    alert(data.msg)
                }
            },
            async getLectureUser(id) {
                let data = await getSources("/bear-scale/api/scaleGroupComboWorkLecture/getLectureUser.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    lectureId:id,
                    rosterStatus:this.rosterStatus,
                });
                if (data.status === 0) {
                    this.lectureId=id;
                    this.lectureUser=data.lectureUser
                    this.lectureNotesMask=true;
                }else{
                    alert(data.msg)
                }
            },
            async doLectureRoster(id,rosterStatus) {
                let data = await getSources("/bear-scale/api/scaleGroupComboWorkLecture/doLectureRoster.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    rosterId:id,
                    rosterStatus:rosterStatus,
                });
                if (data.status === 0) {
                    this.getLectureUser(this.lectureId)
                }else{
                    alert(data.msg)
                }
            },
            async doJoinLecture() {
                let arr=[]
                this.lectureList[0].scaleGroupComboWorkLectureDTOList.forEach(v=>{
                    if(v.status){
                        arr.push(v.workId)
                    }
                })
                let data = await getSources("/bear-scale/api/scaleGroupComboWorkLecture/doJoinLecture.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    lectureId:this.lectureList[0].lectureId,
                    workIdList:arr
                });
                if (data.status === 0) {
                    this.init();
                }else{
                    alert(data.msg)
                }
            },
            async getLectureList() {
                let data = await getSources("/bear-scale/api/scaleGroupComboWorkLecture/getLectureList.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    lectureStatus:this.lectureStatus,
                    pageSize:this.pageSize,
                    pageIndex:this.pageIndex
                });
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    let num=0;
                    if(this.lectureStatus===0){
                        data.lectureList.forEach((v)=>{
                            if(v.scaleGroupComboWorkLectureDTOList.length>0){
                                v.scaleGroupComboWorkLectureDTOList.forEach((item)=>{
                                    item.status=false
                                    if(item.lectureType===1){
                                        num=num+1;
                                        console.log(num)
                                    }
                                })
                            }
                        })
                        this.num=num
                    }



                    this.lectureList = [...this.lectureList, ...data.lectureList];
                    if (data.lectureList.length === 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getLectureList()
                    }
                }
            },


        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getLectureList()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/offlineLectures.vue